<template>
  <div class="notice-container">
    <div class="notice-header">
      <h2 class="title">공지사항</h2>
      <button class="add-button" @click="goToPostPage">+</button>
    </div>

    <hr class="divider"/>

    <ul class="notice-list">
      <notice-item
        v-for="item in notices"
        :key="item.id"
        :notice="item"
        @edit="editNotice"
      />
    </ul>

    <div class="pagination">
      <button @click="loadMore" :disabled="meta && meta.last" v-if="!(meta && meta.last)">더보기</button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import * as noticeApi from '@/api/notice';
import NoticeItem from './NoticeItem.vue';

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export default {
  components: {
    NoticeItem,
  },
  setup() {
    const notices = ref([]);
    const meta = ref(null);
    const router = useRouter();

    const fetchNotices = async (id = null) => {
      try {
        const res = await noticeApi.getNotice(id);
        const responseData = res.data.response;
        const formattedNotices = responseData.notices.map(n => ({ ...n, date: formatDate(n.createdAt) }));

        if (id) {
          notices.value.push(...formattedNotices);
        } else {
          notices.value = formattedNotices;
        }
        meta.value = responseData.meta;
      } catch (error) {
        console.error("공지사항 목록을 불러오는 데 실패했습니다.", error);
      }
    };

    const loadMore = () => {
      if (meta.value && !meta.value.last) {
        const lastId = notices.value[notices.value.length - 1]?.id;
        if (lastId) {
          fetchNotices(lastId);
        }
      }
    };

    const editNotice = (id) => {
      router.push({
        path: "/notice/edit",
        state: { data: id },
      });
    };

    const goToPostPage = () => {
      router.push('/notice/post');
    };

    onMounted(() => {
      fetchNotices();
    });

    return {
      notices,
      meta,
      loadMore,
      editNotice,
      goToPostPage,
    };
  },
};
</script>

<style scoped>
.notice-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0px 32px;
  gap: 16px;
  width: 100%;
  background: #263238;
  border-radius: 20px;
}

.notice-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  width: 100%;
  height: 34px;
  align-self: stretch;
}

.title {
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: -0.3px;
  color: #ECEFF1;
}

.add-button {
  width: 24px;
  height: 24px;
  color: #ECEFF1;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
}

.divider {
  width: 100%;
  border: 1px solid #90A4AE;
}

.notice-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 24px 0px;
  width: 100%;
  align-self: stretch;
}

.pagination button {
  /* 여기에 '더보기' 버튼에 대한 스타일을 추가할 수 있습니다. */
  /* 예를 들어, GuideView와 유사한 스타일을 원하시면 아래 주석을 해제하세요. */
  /*
  background-color: #4A5568;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  */
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>